import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { createUploadLink } from 'apollo-upload-client';
import { getLanguage } from './language';

/**
 * An upload link rather than a plain http link: the careers and whistleblowing
 * forms send a file, and a plain http link would serialise it to json and drop
 * it. It behaves exactly like createHttpLink for every other operation.
 */
const httpLink = createUploadLink({
    uri: process.env.REACT_APP_BACKEND_HOST + '/graphql',
});

const authLink = setContext((_, { headers }) => {
    const language = getLanguage();

    return {
        headers: {
            ...headers,
            ...language && language !== null && { Language: language }
        }
    }
});

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
});


export default client;